// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__rHUhG","strikeOut":"style_strikeOut__FpFZ_","strikeOutWhite":"style_strikeOutWhite__x31_Z","strikeOutRed":"style_strikeOutRed__SeHzI"};